export function formatNpr(amount) {
  return `Rs. ${Number(amount || 0).toFixed(2)}`;
}
